import http from "@/components/services/http-common"

export const confirm = (payload) => {
  return http.post("account/remote-confirm", payload)
}